/* global Backbone, _ */

'use strict';

var Backbone              = require('backbone');
var _                     = require('lodash');

module.exports = Backbone.Model.extend({

    apiUrl: 'https://tailor-dev.telescope.tv/1.0/upload',
    
    defaults: {
      'upload': null,
      'jobId': 0
    },

    //4c6f53ab-c4a9-462c-8bf3-8b32cad21d21
    /**
     * Initialize
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     */
    initialize: function(attributes, options) {
      options = options || {};
      this.auth_token = options.auth_token;
      this.videoUpload = options.videoUpload;
      if(options.apiUrl && options.apiUrl!==''){
        this.apiUrl = options.apiUrl;
      }
    },

    /**
     * Returns URL root
     * @return {String} [description]
     */
    urlRoot: function() {
      //Tailor currently only supports one upload right now, so upload_num is hardcoded to 1.
      if(this.videoUpload)
        return this.apiUrl + '?job_id=' + this.get('jobId') + '&upload_reference=1&Authorization=' + this.auth_token;
      else
        return this.apiUrl + '/image?job_id=' + this.get('jobId') + '&upload_reference=1&Authorization=' + this.auth_token;
    },

    /**
     * Save
     * @param  {Object} attributes [description]
     * @param  {Object} opts       [description]
     * @return {[type]}            [description]
     */
    save: function(attributes, opts) {
      if(typeof this.auth_token === 'undefined' || this.auth_token === null) {
        console.warn('Tailor API requires an authentication token.');
        return;
      }

      var options;

      //IE9!!!
      if (!Backbone.$.support.cors && window.XDomainRequest) {
        //this.apiUrl = this.altUrl;
        this.trigger('unsupported_browser', this);
        console.warn('Browser does not support cross-domain File upload.');
        return;
        // var file = this.get('upload');
        // var form = file.closest('form');
        // file.prop('disabled', false);

        // this.apiUrl = this.altUrl;

        // options = {
        //   iframe: true,
        //   files: form.find(':file')
        // };

        // return Backbone.$.ajax(this.urlRoot(), options).complete(_.bind(function(data) {
        //   var responseText = data.responseText;
        //   var attrs = JSON.parse(responseText);
        //   this.set(attrs, { silent: true });
        //   this.trigger('sync', this);
        // }, this));
      } else {
        var data = new FormData();
        data.append('upload', this.get('upload'));

        options = {
          type: 'POST',
          contentType: false,
          dataType: 'json',
          data: data
        };

      }

      options = _.extend(options, opts);
      return Backbone.Model.prototype.save.call(this, attributes, options);
    }
});